import styled, { ThemeProps } from 'styled-components';
import { Theme } from '../theme';
import { StyledMainComponent } from '../types';

export const Content: StyledMainComponent = styled.main`
  position: relative;
  font-size: ${(props: ThemeProps<Theme>) => props.theme.defaults.fontSize}rem;
  line-height: ${(props: ThemeProps<Theme>) => props.theme.defaults.lineHeight};
  color: ${(props: ThemeProps<Theme>) => props.theme.colors.black};
`;
